module.exports = __webpack_public_path__ + "static/media/element-list-style.d8ae1a86.svg";